// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"4254":"5c2324570f66dff0c8a1","9480":"dfe0a962e5665010f53b"}[chunkId] + "";
};